module.exports = __webpack_public_path__ + "static/img/manual-23.3ebd58d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-23.png
// module id = Zqfv
// module chunks = 4